<template>
    <div class="AudioVolumeControls">
        <SbsTooltip
            position="top"
            content="Выключить звук (m)">
            <SbsButtonIcon
                v-bind="muteButtonData"
                @click.stop="handleMute" />
        </SbsTooltip>
        <CustomRange
            :isDisabled="isMuted || disabled"
            v-model="rangeValue"
            :step="1" />
    </div>
</template>

<script>
import CustomRange from './CustomRange.vue';

export default {
    name: 'AudioVolumeControls',
    components: {
        CustomRange,
    },
    emits: ['update:volume', 'mute'],
    computed: {
        rangeValue: {
            get() {
                return this.modelValue * 100;
            },
            set(newValue) {
                this.$emit('update:modelValue', newValue / 100);
            },
        },
        muteButtonData() {
            return {
                height: '24',
                width: '24',
                iconName: this.isMuted ? 'volume-slash' : 'volume',
                iconGroup: 'regular',
                colorTheme: 'gray-deep',
                hoverColor: 'gray',
                backgroundTheme: 'transparent',
            };
        },
    },
    methods: {
        handleMute() {
            this.$emit('mute');
        },
    },
    props: {
        modelValue: {
            type: Number,
            default: 50,
        },
        isMuted: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>


<style lang="scss" scoped>
.AudioVolumeControls {
    z-index: 2;
    display: flex;
    gap: 10px;
    align-items: center;
}
</style>
